// extracted by mini-css-extract-plugin
export default {"page":"info_page__u9NW3","thnx1":"info_thnx1__l6nG5","thnx2":"info_thnx2__4b0zr","about":"info_about__bsGg9","SFIimg":"info_SFIimg__Q328+","hagarimg":"info_hagarimg__nAgYz"};